// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"styles_checkbox__Uke7z","box":"styles_box__1Dfy_","label":"styles_label__1eZlf"};